import React, { useEffect, useState } from 'react';
import { useTheme } from '../../context/ThemeContext';
import api from '../../api/Api';

const DownlineModal = ({ visible, onClose, levelId }) => {
  const { isDarkMode } = useTheme();
  const [openRow, setOpenRow] = useState(null);
  const [downlineData, setDownlineData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!visible) return;
    fetchLevel();
  }, [visible]);

  if (!visible) return null;

  const fetchLevel = async () => {
    setLoading(true);
    try {
      const res = await api.post('my-team-level-view', { level: levelId });
      if (res.data.status) setDownlineData(res.data.downline);
    } catch (err) {
      console.error('fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  const getInitials = (name) =>
    name.split(' ').slice(0, 2).map((w) => w[0]).join('').toUpperCase();

  const formatDate = (d) =>
    new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });

  const sponsor = downlineData?.[0]?.sponsor;
  const members = downlineData || [];

  const t = (light, dark) => (isDarkMode ? dark : light);

  const s = {
    backdrop: { position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999, padding: 16 },
    modal: { width: '100%', maxWidth: 720, borderRadius: 12, overflow: 'hidden', border: `0.5px solid ${t('rgba(0,0,0,0.1)', 'rgba(255,255,255,0.1)')}`, background: t('#fff', '#1e1e1e') },
    header: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 14px', borderBottom: `0.5px solid ${t('rgba(0,0,0,0.08)', 'rgba(255,255,255,0.08)')}` },
    sponsorRow: { display: 'flex', alignItems: 'center', gap: 10, padding: '8px 14px', background: t('#f5f5f0', '#2a2a2a'), borderBottom: `0.5px solid ${t('rgba(0,0,0,0.08)', 'rgba(255,255,255,0.08)')}` },
    table: { width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed', fontSize: 12 },
    th: { padding: '7px 10px', textAlign: 'left', fontSize: 11, fontWeight: '500', color: t('#888', '#888'), background: t('#f9f9f7', '#252525'), borderBottom: `0.5px solid ${t('rgba(0,0,0,0.08)', 'rgba(255,255,255,0.08)')}` },
    td: { padding: '8px 10px', color: t('#1a1a1a', '#f0f0f0'), borderBottom: `0.5px solid ${t('rgba(0,0,0,0.06)', 'rgba(255,255,255,0.06)')}`, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', verticalAlign: 'middle' },
    tdExp: { padding: '8px 14px', background: t('#f5f5f0', '#2a2a2a'), borderBottom: `0.5px solid ${t('rgba(0,0,0,0.06)', 'rgba(255,255,255,0.06)')}` },
    footer: { display: 'flex', justifyContent: 'space-between', padding: '8px 14px', borderTop: `0.5px solid ${t('rgba(0,0,0,0.08)', 'rgba(255,255,255,0.08)')}`, background: t('#f9f9f7', '#252525') },
  };

  return (
    <div style={s.backdrop}>
      <div style={s.modal}>

        {/* Header */}
        <div style={s.header}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontSize: 14, fontWeight: '500', color: t('#1a1a1a', '#f0f0f0') }}>
              Downline team
            </span>
            <span style={{ background: '#FAEEDA', color: '#633806', fontSize: 11, padding: '2px 8px', borderRadius: 20 }}>
              Level {levelId}
            </span>
          </div>
          <button onClick={onClose} style={{ background: t('#f0f0ee', '#2a2a2a'), border: `0.5px solid ${t('rgba(0,0,0,0.1)', 'rgba(255,255,255,0.1)')}`, borderRadius: '50%', width: 26, height: 26, cursor: 'pointer', color: t('#666', '#aaa'), fontSize: 13 }}>✕</button>
        </div>

        {/* Sponsor */}
        {sponsor && (
          <div style={s.sponsorRow}>
            <img src={sponsor.profile_image} alt="sponsor" style={{ width: 32, height: 32, borderRadius: '50%', border: '1.5px solid #EF9F27', objectFit: 'cover' }} />
            <div>
              <div style={{ fontSize: 13, fontWeight: '500', color: t('#1a1a1a', '#f0f0f0') }}>{sponsor.name}</div>
              <div style={{ fontSize: 11, color: t('#888', '#888') }}>{sponsor.mobile} · {sponsor.fix_address}</div>
            </div>
            <span style={{ marginLeft: 'auto', background: '#FAEEDA', color: '#633806', fontSize: 10, padding: '2px 7px', borderRadius: 8 }}>{sponsor.my_code}</span>
          </div>
        )}

        {/* Table */}
        {loading ? (
          <div style={{ textAlign: 'center', padding: '2rem', color: t('#999', '#666'), fontSize: 13 }}>Loading...</div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={s.table}>
              <thead>
                <tr>
                  <th style={{ ...s.th, width: '36%' }}>Member</th>
                  <th style={{ ...s.th, width: '28%' }}>Mobile</th>
                  <th style={{ ...s.th, width: '20%' }}>Joined</th>
                  <th style={{ ...s.th, width: '16%' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {members.map((m, i) => (
                  <React.Fragment key={m.data.id}>
                    <tr
                      onClick={() => setOpenRow(openRow === i ? null : i)}
                      style={{ cursor: 'pointer', background: openRow === i ? t('#f5f5f0', '#252525') : 'transparent' }}
                    >
                      <td style={s.td}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                          <div style={{ width: 26, height: 26, borderRadius: '50%', background: '#E6F1FB', color: '#0C447C', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: '500', flexShrink: 0 }}>
                            {getInitials(m.user_data.name)}
                          </div>
                          <span style={{ fontSize: 12, fontWeight: '500', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.user_data.name}</span>
                        </div>
                      </td>
                      <td style={{ ...s.td, fontSize: 11, color: t('#888', '#888') }}>{m.user_data.mobile}</td>
                      <td style={{ ...s.td, fontSize: 11, color: t('#888', '#888') }}>{formatDate(m.data.join_date)}</td>
                      <td style={s.td}>
                        <span style={m.user_data.rank_name
                          ? { background: '#e8f5e9', color: '#2e7d32', fontSize: 10, padding: '2px 7px', borderRadius: 20 }
                          : { background: '#fff3e0', color: '#e65100', fontSize: 10, padding: '2px 7px', borderRadius: 20 }}>
                          {m.user_data.rank_name || 'Pending'}
                        </span>
                      </td>
                    </tr>

                    {/* Expanded detail row */}
                    {openRow === i && (
                      <tr>
                        <td colSpan={4} style={s.tdExp}>
                          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0,1fr))', gap: '6px 16px' }}>
                            {[['User ID', m.data.user_id], ['Email', m.user_data.email], ['Stake', `₹${m.user_data.my_stake}`], ['Level', m.data.level]].map(([label, val]) => (
                              <div key={label}>
                                <div style={{ fontSize: 10, color: t('#999', '#666'), marginBottom: 2 }}>{label}</div>
                                <div style={{ fontSize: 12, fontWeight: '500', color: t('#1a1a1a', '#f0f0f0'), overflow: 'hidden', textOverflow: 'ellipsis' }}>{val}</div>
                              </div>
                            ))}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Footer */}
        <div style={s.footer}>
          <span style={{ fontSize: 11, color: t('#888', '#888') }}>Total: <strong style={{ color: t('#1a1a1a', '#f0f0f0') }}>{members.length}</strong> members</span>
          <span style={{ fontSize: 11, color: t('#888', '#888') }}>Team: <strong style={{ color: t('#1a1a1a', '#f0f0f0') }}>{sponsor?.total_team}</strong></span>
        </div>

      </div>
    </div>
  );
};

export default DownlineModal;